import { Navigate } from 'react-router-dom';
import { useChatContext } from '../context/useChatContext.js';
import { isAuthenticated } from '../utils/auth';

/**
 * Redireciona a rota inicial de acordo com o papel do usuário logado.
 * - Super Admins vão direto para Empresas;
 * - Agents globais sem empresa vão para Novidades;
 * - Demais perfis são enviados ao Dashboard.
 */
function InitialRoute() {
  const { isSuperAdmin, isGlobalAdmin, companyId, isAuthReady } = useChatContext();

  const loadingState = (
    <div className="app-boot-loading">
      <div className="app-boot-loading__content">Carregando sessão...</div>
    </div>
  );

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (!isAuthReady) {
    return loadingState;
  }

  // Enquanto não sabemos o papel, não renderizar nada para evitar flicker
  if (isSuperAdmin === null) {
    return loadingState;
  }

  if (isSuperAdmin) {
    return <Navigate to={companyId ? '/dashboard' : '/companyRegister'} replace />;
  }

  if (isGlobalAdmin) {
    return <Navigate to={companyId ? '/dashboard' : '/client-updates'} replace />;
  }

  if (!companyId) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/dashboard" replace />;
}

export default InitialRoute;
